module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_delvechio_sm-1854b9fb6eac63d45d321f19fc79de25.png";